import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AddVersionRequests } from './add-version.requests';
import * as AddVersionActions from './add-version.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { AddVersionErrors } from '@core/models/add-version';

@Injectable()
export class AddVersionEffects {
    constructor(
        private actions$: Actions,
        private addVersionRequests: AddVersionRequests
    ) {}

    submitAddVersion$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddVersionActions.AddVersionActionType.SubmitAddVersion),
            mergeMap((action: AddVersionActions.SubmitAddVersion) =>
                this.addVersionRequests.submitAddVersion$(action.projectId, action.payload).pipe(
                    map((version) => new AddVersionActions.SubmitAddVersionSuccess(version)),
                    catchError((error: HttpErrorResponse) =>
                        of(new AddVersionActions.SubmitAddVersionFailure(error))
                    )
                )
            )
        )
    );

    handleErrors$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddVersionActions.AddVersionActionType.SubmitAddVersionFailure),
            map((action: AddVersionActions.SubmitAddVersionFailure) => {
                const error = action.error;
                const errorFlags: Partial<AddVersionErrors> = {};

                if (error.status === 403) {
                    errorFlags.forbidden = true;
                } else if (error.status === 401) {
                    errorFlags.unauthorized = true;
                } else if (error.status === 500) {
                    errorFlags.server = true;
                } else if (error.status === 406) {
                    const errorCode = error.error?.code;
                    switch (errorCode) {
                        case 'file_not_in_organization':
                        case 'file_not_exists':
                        case 'temporal_file_not_exists':
                            errorFlags.files = true;
                            break;
                        case 'label_not_in_organization':
                        case 'label_not_exists':
                            errorFlags.labels = true;
                            break;
                        case 'version_invalid':
                        case 'subversion_invalid':
                            errorFlags.version = true;
                            break;
                        case 'version_status_not_exists':
                            errorFlags.status = true;
                            break;
                        default:
                            errorFlags.other = true;
                    }
                } else {
                    errorFlags.other = true;
                }

                return new AddVersionActions.SetErrors(errorFlags);
            })
        )
    );
}